import { useEffect, useState } from 'react'
import { BackendPartner, PartnerMetrics } from 'common/types'
import { usePartnerApi } from 'hooks/use-partner-api/usePartnerApi'
import { useParams } from 'react-router-dom'
import { useAuth } from 'pages/auth/hooks/useAuth'

export const usePartnerProfile = () => {
    const { backendUser, backendPartner } = useAuth()
    const { fetchPartner, fetchPartnerMetrics } = usePartnerApi()
    const { partnerId } = useParams<{ partnerId: string }>()
    const [company, setCompany] = useState<BackendPartner>()
    const [publicPage, setPublicPage] = useState<boolean>()
    const [metrics, setMetrics] = useState<PartnerMetrics>()


    useEffect(() => {
        const getCompany = async () => {
            const partner = partnerId ? await fetchPartner(partnerId) : undefined
            if (partner) {
                setCompany(partner)
                if (backendUser) {
                    setPublicPage(!(backendUser?.partnerId === partner.id))
                    if (partner.type === 'corporate' && backendUser?.partnerId === partner.id) {
                        const metricsResponse = await fetchPartnerMetrics(partner?.id)
                        setMetrics(metricsResponse)
                    }
                }
            }
        }
        getCompany()
    }, [partnerId, backendPartner])

    return {
        company,
        publicPage,
        backendUser,
        backendPartner,
        metrics
    } as const
}